import AuthLayout from '@/views/Pages/AuthLayout.vue';
// GeneralViews
import NotFound from '@/views/GeneralViews/NotFoundPage.vue';

const Home = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Home.vue');
const Lastinfo = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Lastinfo.vue');
const Result = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Result.vue');
const Intro = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Intro.vue');
const Benchmark = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Benchmark.vue');
const Qa1 = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Qa1.vue');
const Qa2 = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Qa2.vue');
const Qa3 = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Qa3.vue');


let mainPages = {
  path: '/',
  component: AuthLayout,
  name: 'Pages',
  children: [
    {
      path: '/home',
      name: 'Home',
      component: Home,
    },
    {
      path: '/intro',
      name: 'Intro',
      component: Intro
    },
    {
      path: '/benchmark',
      name: 'Benchmark',
      component: Benchmark
    },
    {
      path: '/qa1',
      name: 'qa1',
      component: Qa1
    },
    {
      path: '/qa2',
      name: 'QA2',
      component: Qa2
    },
    {
      path: '/qa3',
      name: 'QA3',
      component: Qa3
    },
    {
      path: '/lastinfo',
      name: 'lastinfo',
      component: Lastinfo
    },
    {
      path: '/result',
      name: 'result',
      component: Result
    },
    { path: '*', component: NotFound }
  ]
};

const routes = [
  {
    path: '/',
    redirect: '/home',
    name: 'Home'
  },
  mainPages
];

export default routes;
